import { z } from 'zod';

enum Display {
    NORMAL = '',
    NOT_APPLICABLE = 'na',
    HIDDEN = 'hidden',
    UNKNOWN = 'unknown',
}

const DisplayLabels: Record<Display, string> = {
    [Display.NORMAL]: 'Normal',
    [Display.NOT_APPLICABLE]: 'Not applicable',
    [Display.HIDDEN]: 'Hidden',
    [Display.UNKNOWN]: 'Unknown',
};

const IGNORED_FIELD_META_DISPLAYS = [Display.NOT_APPLICABLE, Display.UNKNOWN, Display.HIDDEN];
const getApplicablePortFieldValue = (
    portValues: Record<string, any>,
    portMeta: Record<string, any>,
    field: string,
): number | null | undefined =>
    IGNORED_FIELD_META_DISPLAYS.includes(portMeta?.[field]?.value?.display) ? undefined : portValues?.[field]?.value;

const displaySchema = z.enum([Display.NOT_APPLICABLE, Display.UNKNOWN, Display.HIDDEN]);
const notesSchema = z.string();

const fieldMetaSchema = z
    .object({
        display: displaySchema.optional(),
        notes: notesSchema.optional(),
    })
    .passthrough();

const metadataSchema = z.any();

type FieldMeta = z.infer<typeof fieldMetaSchema>;
type Metadata = z.infer<typeof metadataSchema>;

const metadata = metadataSchema.default({});

export type { FieldMeta, Metadata };
export { Display, DisplayLabels, getApplicablePortFieldValue, IGNORED_FIELD_META_DISPLAYS, metadata };
